const user_details = {
    page_title: 'Chi tiết người dùng',
    back_to_users: 'Về trang quản lý người dùng',
    created_title: 'Người dùng này đã được tạo thành công',
    created_guide: 'Dưới đây là thông tin để hỗ trợ người dùng trong quá trình đăng nhập.',
    created_email: 'Địa chỉ email:',
    created_phone: 'Số điện thoại:',
    created_username: 'Tên đăng nhập:',
    created_password: 'Mật khẩu:',
    menu_delete: 'Xóa',
    delete_description: 'Hành động này không thể hoàn tác. Người dùng sẽ bị xóa vĩnh viễn.',
    deleted: 'Người dùng đã được xóa thành công',
    reset_password: {
        reset_title: 'Bạn có chắc chắn muốn đặt lại mật khẩu không?',
        generate_title: 'Bạn có chắc chắn muốn tạo mật khẩu không?',
        content: 'Hành động này không thể hoàn tác. Thông tin đăng nhập của người dùng sẽ được cập nhật.',
        reset_complete: 'Mật khẩu đã được đặt lại',
        generate_complete: 'Mật khẩu đã được tạo',
        new_password: 'Mật khẩu mới:',
        password: 'Mật khẩu:',
    },
    expire_password: {
        button: 'Cho hết hạn',
        title: 'Bạn có chắc chắn muốn cho mật khẩu này hết hạn không?',
        content: 'Người dùng sẽ phải đặt lại mật khẩu vào lần đăng nhập kế tiếp. Hành động này không thể hoàn tác.',
        success: 'Mật khẩu của người dùng đã được đánh dấu là hết hạn.',
        not_enabled_tooltip: 'Chính sách hết hạn mật khẩu chưa được bật.',
    },
    tab_settings: 'Cài đặt',
    tab_roles: 'Vai trò',
    tab_logs: 'Nhật ký người dùng',
    tab_organizations: 'Organization',
    authentication: 'Xác thực',
    authentication_description: 'Mỗi người dùng có một hồ sơ chứa toàn bộ thông tin người dùng. Hồ sơ gồm dữ liệu cơ bản, danh tính mạng xã hội và dữ liệu tùy chỉnh.',
    user_profile: 'Dữ liệu người dùng',
    field_email: 'Địa chỉ email',
    field_phone: 'Số điện thoại',
    field_username: 'Tên đăng nhập',
    field_password: 'Mật khẩu',
    field_name: 'Tên',
    field_avatar: 'URL ảnh đại diện',
    field_avatar_placeholder: 'https://your.cdn.domain/avatar.png',
    field_custom_data: 'Dữ liệu tùy chỉnh',
    field_custom_data_tip: 'Thông tin người dùng bổ sung không nằm trong các thuộc tính người dùng định trước, ví dụ màu sắc hoặc ngôn ngữ ưa thích của người dùng.',
    field_profile: 'Hồ sơ',
    field_profile_tip: 'Các claim tiêu chuẩn OpenID Connect bổ sung không nằm trong thuộc tính của người dùng. Lưu ý mọi thuộc tính không xác định sẽ bị loại bỏ. Vui lòng xem <a>tài liệu tham khảo thuộc tính hồ sơ</a> để biết thêm thông tin.',
    field_connectors: 'Kết nối mạng xã hội',
    field_sso_connectors: 'Kết nối doanh nghiệp',
    custom_data_invalid: 'Dữ liệu tùy chỉnh phải là một đối tượng JSON hợp lệ',
    profile_invalid: 'Hồ sơ phải là một đối tượng JSON hợp lệ',
    password_already_set: 'Đã đặt mật khẩu',
    no_password_set: 'Chưa đặt mật khẩu',
    connectors: {
        connectors: 'Connector',
        user_id: 'ID người dùng',
        remove: 'Xóa',
        connected: 'Người dùng này đã kết nối với nhiều connector mạng xã hội.',
        not_connected: 'Người dùng chưa kết nối với connector mạng xã hội nào',
        deletion_confirmation: 'Bạn đang xóa danh tính <name/> hiện có. Bạn có chắc chắn muốn tiếp tục không?',
    },
    sso_connectors: {
        connectors: 'Connector',
        enterprise_id: 'ID doanh nghiệp',
        connected: 'Người dùng này đã kết nối với nhiều nhà cung cấp danh tính doanh nghiệp để đăng nhập một lần (SSO).',
        not_connected: 'Người dùng chưa kết nối với nhà cung cấp danh tính doanh nghiệp nào để đăng nhập một lần (SSO).',
    },
    mfa: {
        field_name: 'Xác thực đa yếu tố',
        field_description: 'Người dùng này đã bật xác minh 2 bước.',
        name_column: 'Đa yếu tố',
        field_description_empty: 'Người dùng này chưa bật xác minh 2 bước.',
        deletion_confirmation: 'Bạn đang xóa <name/> hiện có dùng cho xác minh 2 bước. Bạn có chắc chắn muốn tiếp tục không?',
    },
    passkey: {
        field_name: 'Passkey',
        field_description_empty: 'Người dùng này chưa bật đăng nhập bằng passkey.',
        deletion_confirmation: 'Bạn đang xóa <name/> hiện có dùng cho đăng nhập bằng passkey. Bạn có chắc chắn muốn tiếp tục không?',
    },
    suspended: 'Đã tạm khóa',
    suspend_user: 'Tạm khóa người dùng',
    suspend_user_reminder: 'Bạn có chắc chắn muốn tạm khóa người dùng này không? Người dùng sẽ không thể đăng nhập vào ứng dụng của bạn và không thể lấy access token mới sau khi token hiện tại hết hạn. Ngoài ra, mọi yêu cầu API do người dùng này thực hiện sẽ thất bại.',
    suspend_action: 'Tạm khóa',
    user_suspended: 'Người dùng đã bị tạm khóa.',
    reactivate_user: 'Kích hoạt lại người dùng',
    reactivate_user_reminder: 'Bạn có chắc chắn muốn kích hoạt lại người dùng này không? Việc này sẽ cho phép người dùng này đăng nhập trở lại.',
    reactivate_action: 'Kích hoạt lại',
    user_reactivated: 'Người dùng đã được kích hoạt lại.',
    roles: {
        name_column: 'Vai trò người dùng',
        description_column: 'Mô tả',
        assign_button: 'Gán vai trò',
        delete_description: 'Hành động này sẽ xóa vai trò này khỏi người dùng này. Vai trò vẫn sẽ tồn tại nhưng không còn gắn với người dùng này nữa.',
        deleted: '{{name}} đã được xóa khỏi người dùng này.',
        assign_title: 'Gán vai trò cho {{name}}',
        assign_subtitle: 'Tìm vai trò phù hợp bằng cách tìm theo tên, mô tả hoặc ID vai trò.',
        assign_role_field: 'Gán vai trò',
        role_search_placeholder: 'Tìm theo tên vai trò',
        added_text: 'Đã thêm {{value, number}}',
        assigned_user_count: '{{value, number}} người dùng',
        confirm_assign: 'Gán vai trò',
        role_assigned: 'Đã gán vai trò thành công',
        search: 'Tìm theo tên, mô tả hoặc ID vai trò',
        empty: 'Không có vai trò nào',
    },
    warning_no_sign_in_identifier: 'Người dùng cần có ít nhất một định danh đăng nhập (tên đăng nhập, email, số điện thoại hoặc mạng xã hội) để đăng nhập. Bạn có chắc chắn muốn tiếp tục không?',
    personal_access_tokens: {
        title: 'Personal access token',
        title_other: 'Personal access token',
        title_short: 'token',
        empty: 'Người dùng này chưa có personal access token nào.',
        create: 'Tạo token mới',
        tip: 'Personal access token (PAT) cung cấp cách an toàn để người dùng cấp access token mà không cần dùng thông tin đăng nhập và luồng đăng nhập tương tác. Điều này hữu ích cho CI/CD, script hoặc ứng dụng cần truy cập tài nguyên theo cách tự động.',
        value: 'Giá trị',
        created_at: 'Ngày tạo',
        expires_at: 'Ngày hết hạn',
        never: 'Không bao giờ',
        create_new_token: 'Tạo token mới',
        delete_confirmation: 'Hành động này không thể hoàn tác. Bạn có chắc chắn muốn xóa token này không?',
        expired: 'Đã hết hạn',
        expired_tooltip: 'Token này đã hết hạn vào ngày {{date}}.',
        create_modal: {
            title: 'Tạo personal access token',
            expiration: 'Ngày hết hạn',
            expiration_description: 'Token sẽ hết hạn vào {{date}}.',
            expiration_description_never: 'Token này sẽ không bao giờ hết hạn. Chúng tôi khuyến nghị đặt ngày hết hạn để tăng cường bảo mật.',
            days: '{{count}} ngày',
            days_other: '{{count}} ngày',
            created: 'Token {{name}} đã được tạo thành công.',
        },
        edit_modal: {
            title: 'Sửa personal access token',
            edited: 'Token {{name}} đã được sửa thành công.',
        },
    },
    sessions: {
        title: 'Phiên đăng nhập',
        description: 'Quản lý các phiên đăng nhập do Máy chủ ủy quyền sdvico duy trì. Việc thu hồi một phiên sdvico tại đây sẽ ngăn việc tự động chấp thuận cho các yêu cầu ủy quyền sau này.',
        field_name: 'Phiên đăng nhập',
        multiple_signed_in: 'Người dùng này đã đăng nhập trên nhiều thiết bị hoặc trình duyệt.',
        not_found: 'Không tìm thấy phiên sdvico đang hoạt động nào. Người dùng hiện không đăng nhập trên bất kỳ thiết bị nào.',
        name_column: 'Tên',
        session_id_column: 'ID phiên',
        location_column: 'Vị trí',
        browser_on_os: '{{browser}} trên {{os}}',
        user: 'Người dùng',
        applications: 'Ứng dụng',
        signed_in_at: 'Lần đăng nhập gần nhất',
        ip: 'IP',
        browser_name: 'Tên trình duyệt',
        os_name: 'Tên hệ điều hành',
        device_model: 'Model thiết bị',
        revoke_session: 'Thu hồi phiên',
        revoke_session_confirmation: 'Nếu bạn xóa phiên này, người dùng sẽ buộc phải xác thực lại.',
    },
    third_party_apps: {
        title: 'Ứng dụng bên thứ ba',
        description: 'Dùng sdvico làm nhà cung cấp danh tính để ủy quyền cho ứng dụng bên thứ ba. Xem và quản lý các ứng dụng mà người dùng này đã cấp quyền truy cập.',
        field_name: 'Ứng dụng bên thứ ba đã được cấp quyền',
        multiple_authorized: 'Người dùng này đã cấp quyền cho nhiều ứng dụng và dịch vụ bên thứ ba.',
        not_authorized: 'Người dùng này chưa cấp quyền cho ứng dụng hoặc dịch vụ bên thứ ba nào.',
        name_column: 'Tên',
        app_id_column: 'ID ứng dụng',
        access_created_at_column: 'Ngày cấp quyền truy cập',
        revoke_access_title: 'Thu hồi quyền truy cập?',
        revoke_access_description: 'Việc này sẽ thu hồi quyền truy cập của ứng dụng vào tài khoản của người dùng này trên mọi thiết bị. Người dùng phải cấp quyền lại để khôi phục quyền truy cập. Các access token đã cấp trước đó có thể vẫn còn hiệu lực cho đến khi hết hạn.',
    },
    connections: {
        title: 'Kết nối',
        description: 'Người dùng liên kết các tài khoản bên thứ ba để đăng nhập mạng xã hội, SSO doanh nghiệp hoặc truy cập tài nguyên.',
        token_status_column: 'Trạng thái token',
        token_status: {
            active: 'Đang hoạt động',
            expired: 'Đã hết hạn',
            inactive: 'Không hoạt động',
            not_applicable: 'Không áp dụng',
            available: 'Khả dụng',
            not_available: 'Không khả dụng',
        },
    },
};
export default Object.freeze(user_details);
